import { type MetricType } from 'features/charts-v2/types'

// For sentiment/rating, the backend also returns a companion volume metric
// as values[1] when the panel is augmented in use-chart-query.ts.
export const VOLUME_METRIC_FOR: Partial<Record<MetricType, MetricType>> = {
  sentiment: 'sentence_count',
  rating: 'record_count',
}

export const VOLUME_LABEL_FOR: Partial<Record<MetricType, string>> = {
  sentiment: 'Sentences',
  rating: 'Records',
}

/**
 * Get display label for a single metric type
 */
export const getMetricLabel = (metricType: MetricType): string => {
  switch (metricType) {
    case 'record_count':
      return 'Records'
    case 'sentence_count':
      return 'Sentences'
    case 'sentiment':
      return 'Sentiment'
    case 'rating':
      return 'Rating'
    case 'net_promoter_score':
      return 'NPS'
    default:
      return 'Value'
  }
}

/**
 * Get display label for array of metrics (handles multi-metric cases)
 */
export const getMetricsLabel = (selectedMetrics: MetricType[]): string => {
  if (selectedMetrics.length === 1) {
    return getMetricLabel(selectedMetrics[0]!)
  }
  return selectedMetrics.length > 1 ? 'Multiple Metrics' : 'Posts'
}

/**
 * Lowercase unit noun for appending to a formatted tooltip value,
 * e.g. "1,589 sentences", "0.64 sentiment". NPS keeps acronym casing.
 */
export const getMetricUnitLabel = (metricType: MetricType): string => {
  if (metricType === 'net_promoter_score') {
    return 'NPS'
  }
  return getMetricLabel(metricType).toLowerCase()
}

/**
 * Format metric value for display based on metric type
 */
export const formatMetricValue = (
  value: number,
  metricType: MetricType,
): string => {
  if (metricType === 'sentiment' || metricType === 'rating') {
    return value.toFixed(2)
  }
  if (Number.isInteger(value)) {
    return value.toLocaleString()
  }
  return parseFloat(value.toFixed(2)).toLocaleString()
}
